/**
 * Tipos para EmptyView
 */

import React from 'react';

export interface EmptyViewProps {
  /** Tipo de estado vacío */
  type?: 'emptyState' | 'noResults';

  /** Título personalizado (opcional - si no se proporciona, usa i18n) */
  title?: string;

  /** Descripción personalizada (opcional - si no se proporciona, usa i18n) */
  description?: string;

  /** Ícono a mostrar - puede ser un componente de ícono o ReactNode personalizado */
  icon?: React.ReactNode | EmptyViewIconType;

  /** Configuración del botón de acción */
  action?: {
    label: string;
    onClick: () => void;
    testId?: string;
  };

  /** Componente de acción personalizado (opcional) */
  customAction?: React.ReactNode;

  /** Clases CSS adicionales para el contenedor */
  className?: string;

  /** Clases CSS adicionales para el título */
  titleClassName?: string;

  /** Clases CSS adicionales para la descripción */
  descriptionClassName?: string;

  /** Clases CSS adicionales para el ícono */
  iconClassName?: string;

  /** Tamaño del ícono */
  iconSize?: number;
}

export type EmptyViewType = 'emptyState' | 'noResults';

export const EMPTY_VIEW_ICONS = {
  DEFAULT: 'default',
  RETURNED: 'returned',
  LOCATION_MOVEMENTS: 'location-movements',
  STOCK_MOVEMENTS: 'stock-movements',
  MERCHANDISE: 'merchandise',
  LOCATIONS: 'locations',
  ORDER_PREPARATION: 'order-preparation',
  ORDERS_SHIPMENT: 'orders-shipment',
  ORDERS: 'orders',
  PRODUCTS: 'products',
  SHOPS: 'shops',
  ROLES: 'roles',
  HANDS: 'hands',
  COURIERS: 'couriers'
} as const;

export type EmptyViewIconType = typeof EMPTY_VIEW_ICONS[keyof typeof EMPTY_VIEW_ICONS];
